import { Theme } from '@mui/material/styles';
import { createStyles } from "@mui/styles";
import { ReactAutoCompleteStyles } from 'components/AutoComplete/ReactAutoCompleteStyles';

export const Styles = (theme: Theme) => createStyles({

    ...ReactAutoCompleteStyles(theme),

    root: {
        flexGrow: 1,
        margin: 4
    },

    container: {
        position: 'relative',
    },

    paper: {
        position: 'absolute',
        zIndex: 1,
        marginTop: theme.spacing(),
        left: 0,
        right: 0,
    },

    
    divider: {
        height: theme.spacing(2),
    },

    loadMore: {
        fontSize: theme.typography.caption.fontSize,
        color: theme.typography.caption.color
    },

    inputRoot: {
        color: 'inherit',
        width: '100%',
        flexWrap: 'wrap',
    },

    inputInput: {
        display: "block"
    },

    inputUnderline: {
        "&:after": {
            borderBottom: "1px solid inherit"
        }
    },

    inputUnderlineWhite: {
        "&:after": {
            borderBottom: "1px solid " + theme.palette.common.white
        }
    },
    inputUnderlineBlack: {
        "&:after": {
            borderBottom: "1px solid " + theme.palette.common.black
        }
    },

});